import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { provideDfModulePrivacy } from '@df/module-privacy/privacy.providers';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfModuleOnetrust } from './df-module-onetrust.interfaces';
import { OneTrustService } from './onetrust.service';

export function provideDfModuleOneTrust(config?: DeepPartial<NDfModuleOnetrust.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideDfModulePrivacy(),
        {
            provide: NDfModuleOnetrust.OPTIONS,
            useFactory: () => {
                return defaultsDeep(config, NDfModuleOnetrust.defaultOptions);
            }
        },
        provideAppInitializer(() => {
            inject(OneTrustService).appInitialize();
        })
    ]);
}
